import { Quote } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { TESTIMONIALS_FULL } from '../lib/pageContent';
import { TESTIMONIALS_PAGE } from '../constants/testIds';

const META_DESCRIPTION =
  'Read what tire shops, fleets and international distributors say about ordering bulk wholesale used tires from BulkUsedTires.com.';

export default function TestimonialsPage() {
  useDocumentMeta('Customer Testimonials — Bulk Used Tire Buyers | BulkUsedTires.com', META_DESCRIPTION);

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <PageHero
        eyebrow="Testimonials"
        title="Trusted by Shops, Fleets & Exporters"
        description="Wholesale buyers across the US and worldwide on ordering containers, grading accuracy and international shipping."
      />
      <section data-testid={TESTIMONIALS_PAGE.section} className="py-16 sm:py-20">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS_FULL.map((t, i) => (
            <div
              key={t.name}
              data-testid={TESTIMONIALS_PAGE.card(i)}
              className="rounded-2xl border border-brand-border bg-brand-surface p-7"
            >
              <Quote className="w-6 h-6 text-brand-orange mb-4" />
              <p className="text-brand-text text-sm sm:text-base leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
              <p className="mt-5 font-display font-bold text-brand-text uppercase text-sm">{t.name}</p>
              <p className="font-mono text-xs text-brand-muted uppercase tracking-wider">{t.role} &middot; {t.location}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
